import {Injectable} from '@angular/core';
import {FileExtensionValidator} from 'src/app/domain/validators/file-extension.validator';
import {AbstractValidator} from 'src/app/domain/validators/validator';

@Injectable({
  providedIn: 'root'
})
export class VatFileValidator extends AbstractValidator {
  constructor(private fileExtensionValidator: FileExtensionValidator) {
    super();
  }

  isValid(value: File | null): boolean {
    return super.isValid(value);
  }

  validate(value: File | null): void {
    this.fileExtensionValidator.validate(
      value,
      {types: ['pdf', 'jpg', 'png', 'jpeg', 'gif']}
    );
  }
}
